import type {GtmEvent, GtmItem} from "~/types/gtm";

export const useTrackingMkt = () => {
  const {fetch} = useAjax()

  const config = useRuntimeConfig()
  const producer_pixelId = useCookie<string | null>('producer-pixel-id')
  const producer_ga4Id = useCookie<string | null>('producer-ga4-id')
  const ga_client_id = useCookie<string | null>('_ga');
  const fbp = useCookie<string | null>('_fbp');
  const fbc = useCookie<string | null>('_fbc');


  const isDev = () => {
    if (import.meta.server) {
      return config.isDev
    }
    return config.public.isDev
  }

  const trackingEvent = (eventId: string) => {
    try {
      fetch<any>('/event-track/store/' + eventId, {
        method: "POST",
      })
    } catch (e) {
      console.log(e)
    }
  }

  const findProducerConfigEvent = async (eventId: string) => {
    if (!eventId) return
    const gtmData = await fetch<any>(`/events/pub/${eventId}/pixel-events`)
    producer_pixelId.value = gtmData.metaPixel
    producer_ga4Id.value = gtmData.googleAnalytics
  }

  const producerPixelId = computed(() => producer_pixelId.value)
  const producerGa4Id = computed(() => producer_ga4Id.value)

  const sendEvent = (data: GtmEvent) => {
    if (!producer_ga4Id.value && !producer_pixelId.value) return

    const total = data.items.reduce((total: number, item: GtmItem) => total + item.price * item.quantity, 0)

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      debug_mode: isDev(),
      event: data.event,
      producer_ga4_id: producer_ga4Id.value,
      producer_pixel_id: producer_pixelId.value,
      ecommerce: {
        transaction_id: 'TEMP_' + Date.now(),
        value: total,
        currency: 'BRL',
        items: data.items
      },
      user_data: {
        ga_client_id: ga_client_id.value,
        fbp: fbp.value,
        fbc: fbc.value
      }
    });
  }

  return {
    findProducerConfigEvent,
    producerGa4Id,
    producerPixelId,
    sendEvent,
    trackingEvent
  }
}
